import axios from "axios";

export default class Service {
    constructor() {
        this.url = "/api/Account/";
    }

    login(request) {
        return axios.post(this.url + "Login", request);
    }

    logout() {
        return axios.post(this.url + "Logout");
    }

    getPasswordOptions() {
        return axios.get(this.url + "GetPasswordOptions");
    }

    registerClient(request) {
        return axios.post(this.url + "RegisterClient", request);
    }

    confirmEmail(request) {
        return axios.post(this.url + "ConfirmEmail", request);
    }

    changePassword(request) {
        return axios.post(this.url + "ChangePassword", request);
    }

    sendRestorePasswordEmail(email) {
        return axios.post(this.url + "SendRestorePasswordEmail", JSON.stringify(email));
    }

    resetPassword(request) {
        return axios.post(this.url + "ResetPassword", request);
    }
}